import React, { useEffect, useState } from 'react';
import UButton from "../UButton";
import UProgressBar from '../UProgressBar';
import { useHistory, useParams } from 'react-router-dom';

const UPreparingData = (props) => {
  const [isBuilding, setIsBuilding] = useState(true);
  const [loadData, setLoadData] = useState({});

  useEffect(() => {
    on();
    return () => off();
  }, []);

  const {off, refresh, on} = props?.useSocket(res => {
    if (res && !res?.error && res?.data?.socketId === props?.socketId) {
        switch (res.event) {
            case props?.eventName1:
            case props?.eventName2:
                setLoadData(res?.data);
                break
            default:
                return true;
        }
    }
  });

  return (
      <div className="u_acc-form u_collect-details">
        {props?.isLoading ? (
          <>
            <div className="u_flex u_content-center">
              <img src="/images/building.png" alt="building" />
            </div>
            <h4 className="u_title u_text-center u_text-bold u_mt-16 u_mb-16">
              {props?.title}
            </h4>
            <p className="u_small-font u_mb-16 u_text-center">
              {props?.description}
            </p>

            <div className='u_flex-align u_content-center'>
              <UProgressBar
                color="blue"
                animate
                percentage={loadData?.percentage}
                style={{ width: '250px', minWidth: '100px' }}
                showPercent={true}
              />
              <span className="u_text-bold u_color-title u_small-font u_ml-12">
                {loadData?.percentage || 0}%
              </span>
            </div>

            <p className="u_small-font u_mt-16 u_text-center u_color-blue">
              {loadData?.message}
            </p>
          </>
        ) : (
          <>
            <div className="u_flex u_content-center">
              <img src="/images/setup-success.png" alt="setup-success" />
            </div>
            <h4 className="u_title u_text-center u_text-bold u_mt-24 u_mb-12">
              {props?.successTitle || 'Your organization setup successfully'}
            </h4>

            <p className="u_small-font u_mb-24 u_text-center"
              dangerouslySetInnerHTML={{ __html: props?.successDescription || `Let's explore all the features to help your business or company grow.` }}
            />
            
            <div className="u_flex u_content-center">
              <button className="u_btn u_btn__blue small u_flex-align u_flex u_content-center" style={props?.buttonStyle} onClick={() => props?.onSubmit()}>
                {props?.buttonIcon}
                {props?.buttonTitle || 'Go to Dashboard'}
              </button>
              
              {/* <UButton
                style={{ width: 'auto', borderRadius: '6px' }}
                variant="blue"
                type={props?.buttonTitle || 'Go to Dashboard'}
                onClick={() => props?.onSubmit()}
              /> */}
            </div>
          </>
        )}
      </div>
  );
};

export default UPreparingData;